/*
 * ---------------------------------------------------------------------
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 WALC Inc. Inc. All Rights Reserved.
 *
 * file=language-switcher.ts
 *
 * This software is the confidential and proprietary information of WALC Inc.
 * (Confidential Information). You shall not disclose such Confidential Information
 * and shall use it only in accordance with the terms of the license agreement
 * you entered into with WALC Inc.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * <summary>: 表示言語の切替。
 * ---------------------------------------------------------------------
 */


import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { I18nService } from '../../core/i18n/i18n.service';
import type { Locale } from '../../core/i18n/locale';

/** 切替に並べる言語。名前は表示言語によらず、その言語自身の表記で出す。 */
const OPTIONS: readonly { locale: Locale; label: string }[] = [
  { locale: 'ja', label: '日本語' },
  { locale: 'en', label: 'English' },
];

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.html',
  styleUrl: './language-switcher.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguageSwitcher {
  protected readonly i18n = inject(I18nService);
  protected readonly options = OPTIONS;

  protected onSelect(locale: Locale): void {
    this.i18n.setLocale(locale);
  }
}
